import { render, staticRenderFns } from "./PromocoesHotel.vue?vue&type=template&id=70d42576&"
import script from "./PromocoesHotel.vue?vue&type=script&lang=js&"
export * from "./PromocoesHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports